import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { FullLoadingScene } from './fullLoadingScene';
export const LoadingScene = () => {
    const isLoadingDone = useAppSelector((state) => state.session.isLoadingDone);
    if (isLoadingDone) {
        return null;
    }
    return _jsx(FullLoadingScene, {});
};
